<div class="task-detail-container" data-cy="task-detail-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;" data-cy="task-detail-header-section">
      <div class="section-header-title" data-cy="task-detail-title-text">
        Task Detail
      </div>
      <div style="flex: 1;"></div>
    </div>
    
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1;" data-cy="task-detail-content-section"> 
      
      <div class="task-detail-row" data-cy="task-detail-due-row">
        <div class="task-detail-row-label" data-cy="task-detail-due-label">Due:</div>
        <div style="display: flex; padding-top: 3px;" data-cy="task-detail-due-date-container">
          <input style="border-bottom: 1px solid black; background-color: white; height: 20px;" matInput (dateChange)="onDateChange($event)" [ngModel]="data.model.DueDate"
                 [matDatepicker]="pickerEnd"
                 placeholder="End Date" data-cy="task-detail-due-date-input">
          <mat-datepicker-toggle style="position: relative; top: -10px;" matSuffix [for]="pickerEnd" data-cy="task-detail-due-date-toggle"></mat-datepicker-toggle>
          <mat-datepicker #pickerEnd></mat-datepicker>
        </div>
      </div>
      <div class="task-detail-row" data-cy="task-detail-description-row">
        <div class="task-detail-row-label" data-cy="task-detail-description-label">Description:</div>
        <textarea [(ngModel)]="data.model.Description" data-cy="task-detail-description-input"></textarea>
      </div>
      <div class="task-detail-row" style="margin-top: 12px;" data-cy="task-detail-type-row">
        <div class="task-detail-row-label" data-cy="task-detail-type-label">Type:</div>
        <div style="height: 30px; position: relative; top: -18px; width: 400px;" data-cy="task-detail-type-dropdown-container">
          <app-tdo-dropdown [dataSource]="userTaskTypeEnums"
                            [isObjectValue]="true"
                            dataSourceDisplayKey="ItemDisplayValue"
                            (selectionChange)="onUserTaskTypeChange($event)"
                            [value]="getUserTaskType(data.model.enumUserTaskTypeID)" data-cy="task-detail-type-dropdown">
          </app-tdo-dropdown>
        </div>
      </div>
      <div class="task-detail-row" style="margin-top: 14px;" data-cy="task-detail-subject-row">
        <div class="task-detail-row-label" data-cy="task-detail-subject-label">Subject:</div>
        <div style=" overflow-y: hidden;" data-cy="task-detail-subject-container">
          <textarea readonly="true" [value]="getSelectedSubjects()" data-cy="task-detail-subject-input"></textarea>
        </div>
      </div>
      <div class="task-detail-row" style="margin-top: 28px;" data-cy="task-detail-priority-row">
        <div class="task-detail-row-label" data-cy="task-detail-priority-label">Priority:</div>
        <div style="height: 30px; position: relative; top: -18px;" data-cy="task-detail-priority-dropdown-container">
          <app-tdo-dropdown [dataSource]="taskPriorityEnums"
                            [isObjectValue]="true"
                            dataSourceDisplayKey="ItemDisplayValue"
                            (selectionChange)="onUserPriorityChange($event)"
                            [value]="getPriority(data.model.enumTaskPriorityID)" data-cy="task-detail-priority-dropdown">
          </app-tdo-dropdown>
        </div>
      </div>
      <div class="task-detail-row" style="margin-top: 12px;" data-cy="task-detail-status-row">
        <div class="task-detail-row-label" data-cy="task-detail-status-label">Status:</div>
        <div style="height: 30px; position: relative; top: -18px;" data-cy="task-detail-status-dropdown-container">
          <app-tdo-dropdown [dataSource]="taskStatusEnums"
                            [isObjectValue]="true"
                            dataSourceDisplayKey="ItemDisplayValue"
                            (selectionChange)="onStatusChange($event)"
                            [value]="getStatus(data.model.enumTaskStatusID)" data-cy="task-detail-status-dropdown">
          </app-tdo-dropdown>
        </div>
      </div>

      <div style="font-weight: 500; margin-top: 12px;" data-cy="task-detail-created-for-title">Created for</div>
      <hr style="margin-top: 0; background-color: var(--tdo-primary);"/>
      <div style="display: flex;" data-cy="task-detail-created-for-section">
        <div style="flex-basis: 400px;" data-cy="task-detail-users-container">
          <div class="task-detail-row" data-cy="task-detail-user-group-row">
            <div class="task-detail-row-label" data-cy="task-detail-user-group-label">
              User Group:
            </div>
            <div style="flex-basis: 180px;" data-cy="task-detail-user-group-input-container">
              <input style="border-bottom: 1px solid rgba(0,0,0,0.5); background-color: white; height: 20px;" matInput
                     [value]="getUserGroupName(data.model.ForUserGroupID)" readonly data-cy="task-detail-user-group-input">
            </div>
            <div (click)="onUserGroupClick()" style="cursor: pointer; color: var(--tdo-primary-accent); margin-left: 8px;" data-cy="task-detail-select-group-button"><mat-icon>groups</mat-icon></div>
          </div>
          <div class="task-detail-row" data-cy="task-detail-user-row">
            <div class="task-detail-row-label" data-cy="task-detail-user-label">
              User:
            </div>
            <div style="flex-basis: 180px;" data-cy="task-detail-user-input-container">
              <input style="border-bottom: 1px solid rgba(0,0,0,0.5); background-color: white; height: 20px;" matInput
                     [value]="getUserName(data.model.ForUserID)" readonly data-cy="task-detail-user-input">
            </div>
            <div (click)="onOpenSelectUser()" style="cursor: pointer; color: var(--tdo-primary-accent); margin-left: 8px;" data-cy="task-detail-select-user-button"><mat-icon>person</mat-icon></div>
          </div>
          <div class="task-detail-row" data-cy="task-detail-assigned-row">
            <div class="task-detail-row-label" style="margin-bottom: 20px;" data-cy="task-detail-assigned-label">
              Assigned to User:
            </div>
            <div style="flex-basis: 180px;" data-cy="task-detail-assigned-input-container">
              <input style="border-bottom: 1px solid rgba(0,0,0,0.5); background-color: white; height: 20px;" matInput
                     [value]="getUserName(data.model.AssignedToUserID)" readonly data-cy="task-detail-assigned-input">
            </div>
            <div (click)="onOpenAssignUser()" style="cursor: pointer; color: var(--tdo-primary-accent); margin-left: 8px;" data-cy="task-detail-assign-user-button"><mat-icon>person</mat-icon></div>
          </div>
        </div>
        <div (click)="clearUsers()" style="padding-top: 30px; text-align: center; cursor: pointer;" data-cy="task-detail-clear-users-container">
          <button class="tdo-button tdo-save" data-cy="task-detail-clear-users-button">Clear users</button>
        </div>
      </div>
      <hr style="margin-top: 0; background-color: var(--tdo-primary);"/>
      <div class="task-detail-row" style="margin-top: 12px;" data-cy="task-detail-audit-creators-row">
        <div class="task-detail-row-label" data-cy="task-detail-created-by-label">Created By:</div>
        <input style="width: 200px; border-radius: 6px;" [readOnly]="true" [value]="getUser(data.model.xauditCreatedBy)" data-cy="task-detail-created-by-input" />
        <div class="task-detail-row-label" data-cy="task-detail-modified-by-label">Modified By:</div>
        <input style="width: 200px; border-radius: 6px;" [readOnly]="true" [value]="getUser(data.model.xauditModifiedBy)" data-cy="task-detail-modified-by-input" />
      </div>
      <div class="task-detail-row" style="margin-top: 12px;" data-cy="task-detail-audit-dates-row">
        <div class="task-detail-row-label" data-cy="task-detail-created-on-label">Created On:</div>
        <input style="width: 200px; border-radius: 6px;" [readOnly]="true" [value]="getDate(data.model.xauditCreatedOn)" data-cy="task-detail-created-on-input" />
        <div class="task-detail-row-label" data-cy="task-detail-modified-on-label">Modified On:</div>
        <input style="width: 200px; border-radius: 6px;" [readOnly]="true" [value]="getDate(data.model.xauditModifiedOn)" data-cy="task-detail-modified-on-input" />
      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 10px;" data-cy="task-detail-footer-section">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="task-detail-cancel-button">Cancel</button>
      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="task-detail-ok-button">Ok</button>
    </div>
  </div>
</div>
